/* eslint-disable max-len */
import axios, { AxiosResponse } from "axios";
import {
  ICreateCampaign,
  ICreateTestCall,
  ICreateTestMessage,
  IUpdateCampaign,
} from "../models/campaign.model";

export const createCampaign = async (payload: ICreateCampaign) => {
  const res = await axios.post("/create_campaign", payload);
  return res;
};

export const deleteCampaign = async (id: string) => {
  const res = await axios.delete(`/delete_campaign/${id}`);
  return res;
};

export const uploadFile = async (file: File, agentId?: string) => {
  const formData = new FormData();
  formData.append("file", file);
  if (agentId) formData.append("agentId", agentId);
  const res = await axios.post("/create_audience_list", formData);
  return res;
};

export const draftCampaignMessage = async (payload: {
  channel: string;
  current_message: string;
  instruction: string;
}) => {
  const res = await axios.post("/draft_campaign_message", payload);
  return res;
};

export const getCampaigns = async (payload: {
  page: number;
  limit: number;
  keyword: string;
  status: string;
  directionFilter: string;
  sort?: Record<string, 1 | -1>;
  start_date?: string;
}) => {
  const res = await axios.get("/view_campaigns", {
    params: {
      page: payload.page,
      limit: payload.limit,
      keyword: payload.keyword,
      status: payload.status,
      direction_filter: payload.directionFilter,
      sort: payload.sort,
      start_date: payload.start_date || "",
    },
  });
  return res;
};

export const getCampaignById = async (id: string) => {
  const res = await axios.get(`/view_campaign_details`, {
    params: {
      campaign_id: id,
    },
  });
  return res;
};

export const updateCampaign = async (id: string, payload: IUpdateCampaign) => {
  const res = await axios.patch(`/update_campaign/${id}`, payload);
  return res;
};

export const getCampaignReport = async (payload: {
  campaignId?: string;
  agentId?: string;
  page?: number;
  limit?: number;
  keyword?: string;
  direction?: string;
  sort?: Record<string, 1 | -1>;
  exportAll?: boolean;
}) => {
  const keyword = payload.keyword?.trim();
  const params: Record<string, string | number> = {};

  if (payload.campaignId) params.campaign_id = payload.campaignId;
  if (payload.agentId) params.agent_id = payload.agentId;
  if (payload.exportAll) {
    params.export = "true";
  } else if (payload.page != null && payload.page > 0) {
    params.page = payload.page;
    params.limit = payload.limit && payload.limit > 0 ? payload.limit : 10;
  }
  if (keyword) params.keyword = keyword;
  if (payload.direction) params.direction = payload.direction;
  if (payload.sort?.start_time != null) {
    params["sort[start_time]"] = payload.sort.start_time;
  }

  const res = await axios.get(`/call_summary`, { params });
  return res;
};

export const getCampaignReportRecipients = async (
  campaignId: string,
  options?: {
    page?: number;
    limit?: number;
    keyword?: string;
    exportAll?: boolean;
  }
) => {
  const params: Record<string, string | number> = { campaign_id: campaignId };
  if (options?.exportAll) {
    params.export = "true";
  } else if (options?.page != null && options.page > 0) {
    params.page = options.page;
    params.limit = options.limit && options.limit > 0 ? options.limit : 10;
  }
  const keyword = options?.keyword?.trim();
  if (keyword) params.keyword = keyword;
  const res = await axios.get("/campaign_report_recipients", { params });
  return res;
};

export const createTestCall = async (payload: ICreateTestCall) => {
  const res = await axios.post(`/call`, payload);
  return res;
};

export const createTestMessage = async (payload: ICreateTestMessage) => {
  const res = await axios.post(`/send_test_message`, payload);
  return res;
};

export const getListAudiences = async () => {
  const res = await axios.get(`/list_audiences`);
  return res;
};

export const getPresignedAudioUrl = async (url: string | null, sid: string | null) => {
  const res = await axios.post("/call/download", {
    url: url,
    sid: sid,
  });
  return res;
};
